exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown__item-group[data-v-576ee3f8]:not(:first-child) {\n  margin-top: 15px;\n}\n", ""]);

// exports
